export default "__VITE_ASSET__CZwgBEhU__"